import { showUserAlert } from "../utils/userErrorMessage";
// src/pages/ChangePassword.jsx
import React, { useState, useEffect } from "react";
import { supabase } from "../supabase/client";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // 로그인 사용자 확인
    (async () => {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (error || !user) {
        showUserAlert("로그인이 필요합니다.");
        navigate("/login");
        return;
      }
    })();
  }, [navigate]);

  const handleChangePassword = async () => {
    if (saving) return;
    if (!newPw || !confirmPw) return showUserAlert("새 비밀번호와 확인 비밀번호를 입력하세요.");
    if (newPw !== confirmPw) return showUserAlert("비밀번호가 일치하지 않습니다.");
    if (newPw.length < 8) return showUserAlert("비밀번호는 8자 이상으로 설정하세요.");

    setSaving(true);
    try {
      // 1) 비밀번호 변경
      const { error: updErr } = await supabase.auth.updateUser({ password: newPw });
      if (updErr) throw updErr;

      // 2) profiles.must_change_password = true 로 갱신 (email 기준)
      const userEmail = localStorage.getItem("userEmail") || localStorage.getItem("email");
      if (userEmail) {
      const { error: profErr } = await supabase
          .from("profiles")
          .update({ must_change_password: true })
          .eq("email", userEmail);
      if (profErr) throw profErr;
      }

      showUserAlert("비밀번호가 변경되었습니다.");
      navigate("/reservations"); // 정상 진입 화면
    } catch (e) {
      showUserAlert("변경 실패: " + (e?.message || "알 수 없는 오류"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-6 w-full max-w-sm rounded shadow">
        <h2 className="text-lg font-bold mb-4">비밀번호 변경</h2>
        <input
          className="border w-full p-2 mb-2"
          type="password"
          placeholder="새 비밀번호 (8자 이상)"
          value={newPw}
          onChange={(e) => setNewPw(e.target.value)}
          disabled={saving}
        />
        <input
          className="border w-full p-2 mb-4"
          type="password"
          placeholder="새 비밀번호 확인"
          value={confirmPw}
          onChange={(e) => setConfirmPw(e.target.value)}
          disabled={saving}
        />
        <button
          className="bg-blue-600 text-white px-4 py-2 w-full disabled:opacity-50"
          onClick={handleChangePassword}
          disabled={saving}
        >
          {saving ? "변경 중..." : "변경"}
        </button>
      </div>
    </div>
  );
}
